import { TYPES } from "./group.type";

const initState = {
  group: null,
};

const groupReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_GROUP_SERVICE_SUCCESS:
      return {
        ...state,
        group: payload,
      };

    default:
      return state;
  }
};

export default groupReducer;
